import React from "react"

const Hr = () =>
    <div style={{ width: "100%", height: 1, background: "#E0E0E0" }}>

    </div>

export default Hr